export const groupByLanguages = (arr: any[]): any[] => {
  const result = [];
  for (let i = 0; i < arr.length; i += 3) {
    const grupo = {
      'pt-BR': arr[i],
      en: arr[i + 1],
      es: arr[i + 2],
    };
    result.push(grupo);
  }
  return result;
};

const groupOptionsByGroup = (data: any[]): IGroupedOptions =>
  data.reduce((acc: IGroupedOptions, item: any) => {
    const parts = item.Name.split(' / ');
    const group = parts[0];
    const groupName = parts.length === 2 ? parts[0] : parts[1];
    const name = parts.length === 2 ? parts[1] : parts[2];

    if (!acc[group]) {
      acc[group] = [];
    }

    acc[group].push({
      id: item.Id || '',
      label: name,
      groupName,
    });

    return acc;
  }, {});

export const middlewareSurveyQuestions = (data: any): ISurvey[] =>
  data?.map((item: any) => {
    const group = groupOptionsByGroup(item.option);

    return {
      id: item.Id,
      name: item.Title,
      options: group,
    };
  });
